import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getCurrentDate, getPastDate } from "../utils/formatTime";
import { func } from "joi";

//create slice

const initialIrrelavant = {
  FacilityID: 0,
  InmateResidentID: "",
  ManagementUserID: 0,
  // `LastNameValue` and `FirstNameValue` are used to set the value for the Select field components.
  LastNameValue: 0,
  FirstNameValue: 0,
  // `LastName` and `FirstName` are used as parameters in API requests to send the selected values.
  UserFirstName: "",
  UserLastName: "",
  FromDate: getPastDate(1),
  ToDate: getCurrentDate(),
  PodID: 0,
  PageNo: 1,
  RowCountPerPage: 10,
  SortField: "",
};

//Inmate Accessible Menus
const initialInmateAccessibleMenus = {
  FacilityID: 0,
  InmateResidentID: "",
  InmateStatus: 1,
  PageNo: 1,
  RowCountPerPage: 10,
  SortBy: "",
  InmateMenuAccessReports: [],
};

//Shared Pod Tab 4
const initialSharedPod = {
  FacilityID: 0,
  PodID: 0,
  InmateResidentID: "",
  // `LastNameValue` and `FirstNameValue` are used to set the value for the Select field components.
  LastNameValue: 0,
  FirstNameValue: 0,
  // `InmateLastName` and `InmateFirstName` are used as parameters in API requests to send the selected values.
  InmateFirstName: "",
  InmateLastName: "",
  SharedStatus: 1,
  FromDate: getPastDate(1),
  ToDate: getCurrentDate(),
  PageNo: 1,
  RowCountPerPage: 10,
  SortField: "",
};

const initialKioskAccessReport = {
  FacilityID: 0,
  PodID: 0,
  InmateResidentID: "",
  LastName: "",
  FirstName: "",
  LastNameValue: 0,
  FirstNameValue: 0,
  FromDate: getPastDate(1),
  ToDate: getCurrentDate(),
  AnyKioskInmateStatus: 1,
  PageNo: 1,
  RowCountPerPage: 10,
  SortField: "",
};

const name = "logReport";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

//Exports
export const logReportAction = { ...slice.actions, ...extraActions };
export const logReportReducer = slice.reducer;

//Implementation

function createInitialState() {
  return {
    loading: false,
    error: null,

    //KioskReport
    loadInactivekiosk: [],
    loadInactivekioskFullList: [],
    FacilityList: [],
    PODList: [],
    KioskList: [],

    //Irrelevant POD Access
    irrelevant: initialIrrelavant,
    invalidLogReportList: [],
    invalidLogReportFullList: [],
    inmateinvalidLogDetails: {},

    //Inmate Accessbile Menus
    InmateAccessMenus: initialInmateAccessibleMenus,
    inmateAccessReportList: {},
    inmateAccessReportFullList: {}, //For Excel download
    inmateAccessibleMenuList: {
      data: null,
      loading: false,
    },

    //Shared POD
    SharedPod: initialSharedPod,
    SharedPodLogReport: {},
    SharedPodFullLogReport: {},
    SharedPodAccessDetails: {},

    //Kiosk Access Inmate Report
    KioskAccessReport: initialKioskAccessReport,
    KioskAccessGridList: {},
    KioskAccessGridFullList: {},
    kioskAccessDetails: {},
  };
}

function createReducers() {
  return {
    //KioskReport
    clearexcelData,

    //Irrelevant POD Access
    setIrrelevant,
    clearIrrelevant,
    clearLogReportFullList, //clear the excelData After download

    //Inmate Accessible Menus
    setInmateMenu,
    clearInmateMenu,
    clearinmateAccessReportFullList, //clear the excelData After download
    clearinmateAccessReportList, // Clears the grid data when the Accessible Menu is cleared, ensuring no previous data remains when a new search is performed.
    //SharedPod
    setSharedPod,
    resetSharedPod,
    clearSharedPodFullLogReport, //clear the excelData After download

    //Kiosk Access Inmate Report
    //Used to set the State Values
    setkioskAccess,
    resetKioskAccess, //reset Func
    clearKioskFullList, //clear the excelData After download
  };

  //KioskReport
  function clearexcelData(state) {
    state.loadInactivekioskFullList = [];
  }

  //Irrelevant POD Access
  function setIrrelevant(state, action) {
    state.irrelevant = action && action.payload;
  }

  function clearIrrelevant(state) {
    state.irrelevant = initialIrrelavant;
    state.invalidLogReportList = [];
  }

  function clearLogReportFullList(state) {
    state.invalidLogReportFullList = [];
  }

  //Inmate Accessible Menus
  function setInmateMenu(state, action) {
    state.InmateAccessMenus = action && action.payload;
  }

  function clearInmateMenu(state) {
    state.InmateAccessMenus = {
      ...initialInmateAccessibleMenus,
      InmateMenuAccessReports: [], // Ensure Accessible Menu is explicitly cleared
    };
    state.inmateAccessReportList = {}; // Clear grid data
  }

  function clearinmateAccessReportList(state) {
    state.inmateAccessReportList = {};
  }

  function clearinmateAccessReportFullList(state) {
    // clear the List data after export the excel
    state.inmateAccessReportFullList = {};
  }

  //Share POD
  function setSharedPod(state, action) {
    state.SharedPod = action && action.payload;
  }

  function resetSharedPod(state) {
    state.SharedPod = initialSharedPod;
    state.SharedPodLogReport = {};
  }

  function clearSharedPodFullLogReport(state) {
    state.SharedPodFullLogReport = {};
  }

  //Kiosk Access
  function setkioskAccess(state, action) {
    state.KioskAccessReport = action && action.payload;
  }

  function resetKioskAccess(state) {
    state.KioskAccessReport = initialKioskAccessReport;
    state.KioskAccessGridList = {};
  }

  function clearKioskFullList(state) {
    state.KioskAccessGridFullList = {};
  }
}

function createExtraActions() {
  const baseURL = `${process.env.REACT_APP_API_URL}`;

  return {
    //KioskReport
    GetFacilityList: GetFacilityList(),
    GetPODWithoutFacilityList: GetPODWithoutFacilityList(),
    GetKioskWithoutFacilityList: GetKioskWithoutFacilityList(),
    LoadInactivekiosk: LoadInactivekiosk(),

    //Irrelevant POD Access
    InmateInvalidLogReport: InmateInvalidLogReport(),
    InmateInvalidLogDetails: InmateInvalidLogDetails(),

    //Inmate Accessible Menus
    InmateAccessReport: InmateAccessReport(),
    InmateAccessibleMenuList: InmateAccessibleMenuList(),

    //SharedPod
    SharedPodAccessInmateLogReport: SharedPodAccessInmateLogReport(),
    SharedPodAccessInmateReportDetails: SharedPodAccessInmateReportDetails(),

    //Kiosk Access Inmate Report
    AnyKioskAccessInmateReport: AnyKioskAccessInmateReport(),
    AnyKioskAccessInmateReportDetails: AnyKioskAccessInmateReportDetails(),
  };

  //KioskReport
  function GetFacilityList() {
    return createAsyncThunk(`${name}/GetFacilityList`, async () => {
      return await fetchWrapper.get(`${baseURL}/Master/GetFacilityList`);
    });
  }

  function GetPODWithoutFacilityList() {
    return createAsyncThunk(
      `${name}/Master/GetPODWithoutFacilityList`,
      async (id) => {
        return await fetchWrapper.get(
          `${baseURL}/Master/GetPODWithoutFacilityList?facilityID=${id}`
        );
      }
    );
  }

  function GetKioskWithoutFacilityList() {
    return createAsyncThunk(
      `${name}/GetKioskWithoutFacilityList`,
      async ({ podId, FaciltiyId }) => {
        return await fetchWrapper.get(
          `${baseURL}/Master/GetKioskWithoutFacilityList?podID=${podId}&?facilityID=${FaciltiyId}`
        );
      }
    );
  }

  function LoadInactivekiosk() {
    return createAsyncThunk(`${name}/LoadInactivekiosk`, async (param) => {
      return await fetchWrapper.post(
        `${baseURL}/MangementUser/LogReport/LoadInactivekiosk`,
        param
      );
    });
  }

  //Irrelevant POD Access
  function InmateInvalidLogReport() {
    return createAsyncThunk(`${name}/InmateInvalidLogReport`, async (param) => {
      return await fetchWrapper.post(
        `${baseURL}/MangementUser/LogReport/InmateInvalidLogReport`,
        param
      );
    });
  }

  function InmateInvalidLogDetails() {
    return createAsyncThunk(
      `${name}/InmateInvalidLogDetails`,
      async (param) => {
        return await fetchWrapper.post(
          `${baseURL}/MangementUser/LogReport/InmateInvalidLogDetails`,
          param
        );
      }
    );
  }

  function InmateAccessReport() {
    return createAsyncThunk(`${name}/InmateAccessReport`, async (param) => {
      return await fetchWrapper.post(
        `${baseURL}/MangementUser/LogReport/InmateAccessReport`,
        param
      );
    });
  }

  function InmateAccessibleMenuList() {
    return createAsyncThunk(
      `${name}/InmateAccessibleMenuList`,
      async ({ FacilityID, InmateId }) => {
        return await fetchWrapper.post(
          `${baseURL}/MangementUser/LogReport/InmateAccessibleMenuList?facilityID=${FacilityID}&inmateId=${InmateId}`
        );
      }
    );
  }

  function SharedPodAccessInmateLogReport() {
    return createAsyncThunk(
      `${name}/SharedPodAccessInmateLogReport`,
      async (param) => {
        return await fetchWrapper.post(
          `${baseURL}/MangementUser/LogReport/SharedPodAccessInmateLogReport`,
          param
        );
      }
    );
  }

  function SharedPodAccessInmateReportDetails() {
    return createAsyncThunk(
      `${name}/SharedPodAccessInmateReportDetails`,
      async (param) => {
        return await fetchWrapper.post(
          `${baseURL}/MangementUser/LogReport/SharedPodAccessInmateReportDetails`,
          param
        );
      }
    );
  }

  function AnyKioskAccessInmateReport() {
    return createAsyncThunk(
      `${name}/AnyKioskAccessInmateReport`,
      async (param) => {
        return await fetchWrapper.post(
          `${baseURL}/MangementUser/LogReport/AnyKioskAccessInmateReport`,
          param
        );
      }
    );
  }

  function AnyKioskAccessInmateReportDetails() {
    return createAsyncThunk(
      `${name}/AnyKioskAccessInmateReportDetails`,
      async (param) => {
        return await fetchWrapper.post(
          `${baseURL}/MangementUser/LogReport/AnyKioskAccessInmateReportDetails`,
          param
        );
      }
    );
  }
}

function createExtraReducers(builder) {
  builder
    //KioskReport 1st tab
    .addCase(extraActions.GetFacilityList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetFacilityList.fulfilled, (state, action) => {
      state.FacilityList = action && action?.payload;

      state.loading = false;
    })
    .addCase(extraActions.GetFacilityList.rejected, (state, action) => {
      state.loading = false;
      state.error = action && action.error;
    })

    //GetPODWithoutFacilityList
    .addCase(extraActions.GetPODWithoutFacilityList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetPODWithoutFacilityList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.PODList = action && action?.payload;
      }
    )
    .addCase(
      extraActions.GetPODWithoutFacilityList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action && action.error;
      }
    )
    // GetKioskWithoutFacilityList
    .addCase(extraActions.GetKioskWithoutFacilityList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetKioskWithoutFacilityList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.KioskList = action && action?.payload;
      }
    )
    .addCase(
      extraActions.GetKioskWithoutFacilityList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action && action.error;
      }
    )

    //LoadInactivekiosk
    .addCase(extraActions.LoadInactivekiosk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadInactivekiosk.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.loadInactivekioskFullList = action && action.payload;
      } else {
        state.loadInactivekiosk = action && action.payload;
      }

      state.loading = false;
    })
    .addCase(extraActions.LoadInactivekiosk.rejected, (state, action) => {
      state.loading = false;
      state.error = action && action.error;
    })

    //Irrelevant POD Access 2nd Tab
    .addCase(extraActions.InmateInvalidLogReport.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.InmateInvalidLogReport.fulfilled, (state, action) => {
      let param = action.meta.arg;
      if (param?.exportExcel) {
        state.invalidLogReportFullList = action && action.payload;
      } else {
        state.invalidLogReportList = action && action.payload;
      }

      state.loading = false;
    })
    .addCase(extraActions.InmateInvalidLogReport.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
    })

    //InmateInvalidLogDetails
    .addCase(extraActions.InmateInvalidLogDetails.pending, (state) => {
      state.inmateinvalidLogDetails.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.InmateInvalidLogDetails.fulfilled,
      (state, action) => {
        state.inmateinvalidLogDetails.loading = false;
        state.inmateinvalidLogDetails = action && action.payload;
      }
    )
    .addCase(extraActions.InmateInvalidLogDetails.rejected, (state, action) => {
      state.inmateinvalidLogDetails.loading = false;
      state.error = action.error;
    })

    //Inmate accessible Menu 3rd Tab
    .addCase(extraActions.InmateAccessReport.pending, (state) => {
      state.inmateAccessReportList.loading = true;
      state.error = null;
    })
    .addCase(extraActions.InmateAccessReport.fulfilled, (state, action) => {
      let param = action.meta.arg;

      if (param.exportExcel) {
        state.inmateAccessReportFullList = action && action.payload;
      } else {
        state.inmateAccessReportList = action && action.payload;
      }
      state.inmateAccessReportList.loading = false;
    })
    .addCase(extraActions.InmateAccessReport.rejected, (state, action) => {
      state.inmateAccessReportList.loading = false;
      state.inmateAccessReportList = {}
      state.error = action.error;
    })
    //InmateAccessibleMenuList Popup Grid
    .addCase(extraActions.InmateAccessibleMenuList.pending, (state) => {
      state.inmateAccessibleMenuList.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.InmateAccessibleMenuList.fulfilled,
      (state, action) => {
        state.inmateAccessibleMenuList.data = action && action.payload;

        state.inmateAccessibleMenuList.loading = false;
      }
    )
    .addCase(
      extraActions.InmateAccessibleMenuList.rejected,
      (state, action) => {
        state.inmateAccessibleMenuList.loading = false;
        state.error = action.error;
      }
    )

    //Shared POD Tab 4
    .addCase(extraActions.SharedPodAccessInmateLogReport.pending, (state) => {
      state.SharedPodLogReport.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.SharedPodAccessInmateLogReport.fulfilled,
      (state, action) => {
        let param = action.meta.arg;

        if (param.exportExcel) {
          state.SharedPodFullLogReport = action && action.payload;
        } else {
          state.SharedPodLogReport = action && action.payload;
        }
        state.SharedPodLogReport.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.SharedPodAccessInmateLogReport.rejected,
      (state, action) => {
        state.SharedPodLogReport.loading = false;
        state.error = action.error;
      }
    )

    //Popup Table List (DETAILS OF SHARED POD ACCESS )

    .addCase(
      extraActions.SharedPodAccessInmateReportDetails.pending,
      (state) => {
        state.SharedPodAccessDetails.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.SharedPodAccessInmateReportDetails.fulfilled,
      (state, action) => {
        state.SharedPodAccessDetails.loading = false;
        state.SharedPodAccessDetails = action && action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.SharedPodAccessInmateReportDetails.rejected,
      (state, action) => {
        state.SharedPodAccessDetails.loading = false;
        state.error = action.error;
      }
    )

    //Any Kiosk Access Report
    .addCase(extraActions.AnyKioskAccessInmateReport.pending, (state) => {
      state.KioskAccessGridList.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.AnyKioskAccessInmateReport.fulfilled,
      (state, action) => {
        let param = action.meta.arg;

        if (param.exportExcel) {
          state.KioskAccessGridFullList = action && action.payload;
        } else {
          state.KioskAccessGridList = action && action.payload;
        }
        state.KioskAccessGridList.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.AnyKioskAccessInmateReport.rejected,
      (state, action) => {
        state.KioskAccessGridList.loading = false;
        state.error = action.error;
      }
    )
    //Popup Grid List for Any Access Kiosk Inmate Report
    .addCase(
      extraActions.AnyKioskAccessInmateReportDetails.pending,
      (state) => {
        state.kioskAccessDetails.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.AnyKioskAccessInmateReportDetails.fulfilled,
      (state, action) => {
        state.kioskAccessDetails.loading = false;
        state.kioskAccessDetails = action && action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.AnyKioskAccessInmateReportDetails.rejected,
      (state, action) => {
        state.kioskAccessDetails.loading = false;
        state.error = action.error;
      }
    );
}
